import $ from 'jquery';
import Helper from 'helpers/util';

const playStoreLink = (target) => {
	let storeUrl;
	// GOOGLE PLAY APP LINK
	// fire tracking event
	if (window.ga) {
		window.ga('send', 'event', 'App Link', 'visited', 'Google Play');
	}
	if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
		// mobile
		storeUrl = window.androidMarketLink ? window.androidMarketLink : 'market://details?id=com.webling.hungryjacks';

	} else {
		// desktop
		storeUrl = window.androidHttpLink ? window.androidHttpLink : 'https://play.google.com/store/apps/details?id=com.webling.hungryjacks';
	}

	if (target === '_blank') {
		window.open(storeUrl, '_blank');
	} else {
		document.location.href = storeUrl;
	}
}

const appleStoreLink = (target) => {
	let storeUrl;
	// APPLE APP LINK
	// fire tracking event
	if (window.ga) {
		window.ga('send', 'event', 'App Link', 'visited', 'Apple');
	}
	if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
		// mobile
		storeUrl = window.iosMarketLink ? window.iosMarketLink : 'itms://itunes.apple.com/au/app/hungry-jacks-shake-win-app/id518981155?mt=8';
	} else {
		// desktop
		storeUrl = window.iosHttpLink ? window.iosHttpLink : 'https://itunes.apple.com/au/app/hungry-jacks-shake-win-app/id518981155';
	}

	if (target === '_blank') {
		window.open(storeUrl, '_blank');
	} else {
		document.location.href = storeUrl;
	}
}

// Logic for query string app link detection
Helper.pubsub.subscribe('googleAnalyticsLoaded', () => {

	if (Helper.getParameterByName('appLink') === 'apple') {
		appleStoreLink();
	} else if (Helper.getParameterByName('appLink') === 'play') {
		playStoreLink();
	}

	// prevent default binding for app link buttons in site
	$(document).on('click', 'a[href="?appLink=apple"]', function(event) {
		event.preventDefault();
		appleStoreLink('_blank');
	});
	$(document).on('click', 'a[href="?appLink=play"]', function(event) {
		event.preventDefault();
		playStoreLink('_blank');
	});

});
